export const RESET_ERROR = 'reports/RESET_ERROR';
export const FETCH_REPORT_A3PAIDFINE = 'reports/FETCH_REPORT_A3PAIDFINE';
export const FETCH_REPORT_A3PAIDFINE_SUCCESS = 'reports/FETCH_REPORT_A3PAIDFINE_SUCCESS';
export const FETCH_REPORT_A3PAIDFINE_FAIL = 'reports/FETCH_REPORT_A3PAIDFINE_FAIL';

export const FETCH_REPORT_A3AVAILABILITY = 'reports/FETCH_REPORT_A3AVAILABILITY';
export const FETCH_REPORT_A3AVAILABILITY_SUCCESS = 'reports/FETCH_REPORT_A3AVAILABILITY_SUCCESS';
export const FETCH_REPORT_A3AVAILABILITY_FAIL = 'reports/FETCH_REPORT_A3AVAILABILITY_FAIL';

export const FETCH_REPORT_CLIENT_REGISTRATION = 'reports/FETCH_REPORT_CLIENT_REGISTRATION';
export const FETCH_REPORT_CLIENT_REGISTRATION_SUCCESS = 'reports/FETCH_REPORT_CLIENT_REGISTRATION_SUCCESS';
export const FETCH_REPORT_CLIENT_REGISTRATION_FAIL = 'reports/FETCH_REPORT_CLIENT_REGISTRATION_FAIL';
